export const range = (size: number) => {
  return [...Array(size).keys()]
}
